import {Injectable} from '@angular/core';
import {IProdGridService} from 'prod-grid';
import {HttpClient} from "@angular/common/http";
import {HttpExtraParams, HttpFilterParam} from 'prod-shared';
import {Observable} from 'rxjs';
import {IProdFormService} from 'prod-form';
import {DeviceEvent} from "../models/device-event";
import {OrganizationTreeSelect} from "../dip/organization-tree-select";

@Injectable({providedIn: 'root'})
export class DeviceEventService implements IProdGridService, IProdFormService {
  constructor(private httpClient: HttpClient, private organizationTreeSelect: OrganizationTreeSelect) {
  }

  getProdGridData(params?: HttpExtraParams): Observable<Object> {
    return this.httpClient.get<{ data: { result: DeviceEvent[], totalCount: number }, success: boolean }>(`/api/deviceEvents`, {params});
  }

  prodGridAdd(values: any): Observable<Object> {
    return this.httpClient.post(`/api/deviceEvent/${values['carId']}/addBatteryEvent`, values);
  }

  prodGridPatch(values: any, id: number): Observable<Object> {
    throw new Error('Method not implemented.');
  }

  prodGridRemove(id: number): Observable<Object> {
    throw new Error('Method not implemented.');
  }

  getOrganizationFilter(): HttpFilterParam[] {
    return [new HttpFilterParam({
      property: 'organization.id',
      operator: 'in',
      value: this.organizationTreeSelect.ids
    })];
  }
}
